import instance from "../../axios/config";
import { trackEvent } from "./appInsights";

const isUsageEndpointEnabled = process.env.REACT_APP_USAGE_ENDPOINT_ENABLED !== "false";

const getTokenStorage = () => {
  try {
    return JSON.parse(localStorage.getItem("okta-token-storage"));
  } catch {
    return null;
  }
};

const isAuthenticated = () => {
  const tokenStorage = getTokenStorage();

  return Boolean(tokenStorage?.idToken?.idToken);
};

export const sendUsageEvent = (action, payload = {}) => {
  if (!isAuthenticated()) {
    return;
  }

  const usagePayload = {
    action,
    feature: payload.feature || "nimblelab_ui",
    path: payload.path || window.location.pathname,
    pageTitle: document.title,
    metadata: payload.metadata || {},
  };

  trackEvent("nl_usage_event", {
    action,
    feature: usagePayload.feature,
    path: usagePayload.path,
    pageTitle: usagePayload.pageTitle,
    ...usagePayload.metadata,
  });

  if (!isUsageEndpointEnabled) {
    return;
  }

  instance.post("/usage/event", usagePayload).catch(() => undefined);
};